// 按钮组件
import lButton from './lButton'
// 输入框组件
import lInput from './lInput'
// 瀑布流组件
import lWaterfall from './lWaterfall'

const COMPONENTS = [lButton,lInput,lWaterfall]

export default COMPONENTS